import ClientApp from './mount-react-app.client';
import ServerApp from './mount-react-app.server';

const isServer = typeof window === 'undefined';

export default isServer ? ServerApp : ClientApp;